// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/scss/main.scss
// module id = 86
// module chunks = 23